import { Component, Input, ViewChild } from '@angular/core';
import { BsModalRef, ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environment';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-onboarding-landing-modal',
    templateUrl: './onboarding-landing-modal.component.html',
    styleUrls: ['./onboarding-landing-modal.component.scss'],
    imports: [ModalModule, InlineSVGComponent, TranslateModule],
})
export class OnboardingLandingModalComponent {
    @ViewChild('autoShownModal') autoShownModal: ModalDirective;
    @Input() isModalShown: boolean;

    modalRef: BsModalRef;
    socialMediaStatuses = {
        facebook: false,
        instagram: false,
    };
    adminUrlBase: string;

    constructor(
        public activatedRoute: ActivatedRoute,
        public commonDataService: CommonDataService,
        public router: Router,
        public windowRef: WindowRef,
    ) {
        this.adminUrlBase = environment.settingsUrl + commonDataService.community + '/';

        const { facebook, instagram } = this.commonDataService.socialMediaStatuses;

        this.socialMediaStatuses = { facebook, instagram };
    }

    hideModal(): void {
        this.autoShownModal.hide();
    }

    onHidden(): void {
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { ticketId: this.activatedRoute.snapshot.queryParams['ticketId'] },
        });
        this.isModalShown = false;
    }

    openInstallationPage(typeName: string): void {
        window.location.href = this.adminUrlBase + 'community/installation/' + typeName;
    }

    showModal(): void {
        this.isModalShown = true;
    }
}
